import { render, staticRenderFns } from "./VInventoryTemplateCard.vue?vue&type=template&id=00953326"
import script from "./VInventoryTemplateCard.vue?vue&type=script&lang=js"
export * from "./VInventoryTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./VInventoryTemplateCard.vue?vue&type=style&index=0&id=00953326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports